
import { canonical } from "@utils";
import { getCMSCopy } from "@/common/services/cmsCopyService";

import { AD_LAYOUT_STUBS, PAGES } from "@/common/consts";

const CMS_COPY_KEYS = {
	[PAGES.POPULAR_PAGES]: ".seo.popular.popular-pages",
	[PAGES.TOP_SEARCHED]: ".seo.popular.top-searched-word-combos",
	[PAGES.TOP_UNSCRAMBLES]: ".seo.popular.top-unscrambles",
	[PAGES.FIVE_LETTER_WORD_LISTS]: ".seo.popular.5-letter-word-lists",
};

export default {
	name: "SingleCMSPage",
	data() {
		return {
			AD_LAYOUT_STUBS,
			pageData: {},
		};
	},
	// fetch: content loading (SSR + client nav). Non-blocking on the client, so
	// navigating here no longer freezes the route transition.
	async fetch() {
		await this.loadData();
	},
	head() {
		const m = {};

		const title = this.pageData?.metaTitle;
		if (title) {
			m.title = title;
		}

		const description = this.pageData?.metaDescription;
		if (description) {
			m.meta = [
				{
					name: "description",
					content: description,
				},
			];
		}

		m.link = [canonical(this.$route)];
		return m;
	},
	computed: {
		pageTitle() {
			return this.pageData?.title;
		},
		pageBodyCopy() {
			return this.pageData?.body;
		},
	},
	methods: {
		async loadData() {
			const cmsCopyKey = CMS_COPY_KEYS[this.$route.name];
			if (!cmsCopyKey) {
				this.pageData = {};
				return;
			}

			const cmsCopy = await getCMSCopy(
				this.$axios,
				this.$config,
				cmsCopyKey,
				process.env.version
			);

			this.pageData = cmsCopy?.data || {};
		},
		onBodyCopyClick(e) {
			if (
				e?.target?.tagName?.toUpperCase() === "A" &&
				e.target.hasAttribute("href") &&
				e.target.getAttribute("target") !== "_blank" &&
				(/\/\/wordfinder\.yourdictionary\.com/.test(
					e.target.getAttribute("href")
				) ||
					/^\/[^/]/.test(e.target.getAttribute("href")))
			) {
				const href = e.target
					.getAttribute("href")
					.replace(/^https?:\/\/wordfinder\.yourdictionary\.com/, "");
				e.preventDefault();
				this.$router.push(href);
			}
		},
	},
};
